import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

enum MaterialTypes {
  Dry = 1,
  Liquid = 2,
  Cement = 3,
  LiquidBase = 4,
  Pozolan = 5,
  LiquidAdditive = 6,
  SpacerDryBase = 7,
  SpacerDryFractionBase = 8,
  SpacerLiquidBase = 9,
  SpacerLiquidFractionBase = 10,
  SpacerDryAdditive = 11,
  SpacerLiquidAdditive = 12
}

interface MaterialTypeOption {
  label: string;
  value: MaterialTypes;
}

const MATERIAL_TYPE_OPTIONS: MaterialTypeOption[] = [
  { label: 'Dry Additive', value: MaterialTypes.Dry },
  { label: 'Liquid Additive', value: MaterialTypes.Liquid },
  { label: 'Cement', value: MaterialTypes.Cement },
  { label: 'Liquid Base', value: MaterialTypes.LiquidBase },
  { label: 'Poz', value: MaterialTypes.Pozolan },
  { label: 'Spacer Dry Base', value: MaterialTypes.SpacerDryBase },
  { label: 'Fraction Spacer Dry Base', value: MaterialTypes.SpacerDryFractionBase },
  { label: 'Spacer Liquid Base', value: MaterialTypes.SpacerLiquidBase },
  { label: 'Fraction Spacer Liquid Base', value: MaterialTypes.SpacerLiquidFractionBase }
];

export interface AddMaterialResult {
  name: string;
  functionName: string;
  specificGravity: number | null;
  sackWeightLb: number | null;
  materialType: number;
  addAfterStirring: boolean;
  isActive: boolean;
  doNotRunFluidLossTestWithFoamers: boolean;
}

@Component({
  selector: 'app-add-material-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  templateUrl: './add-material-dialog.component.html',
  styleUrl: './add-material-dialog.component.css',
})
export class AddMaterialDialogComponent {
  
  readonly materialTypeOptions = MATERIAL_TYPE_OPTIONS;

  data: AddMaterialResult = {
    name: '',
    functionName: '',
    specificGravity: null,
    sackWeightLb: null,
    materialType: MaterialTypes.Dry, 
    addAfterStirring: false,
    isActive: true,
    doNotRunFluidLossTestWithFoamers: false
  };

  constructor(
    public dialogRef: MatDialogRef<AddMaterialDialogComponent>
  ) {}

  get isValid(): boolean {
    return this.data.name.length > 0;
  }

  onSubmit(): void {
    if (!this.isValid) {
      return;
    }
    this.dialogRef.close(this.data);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
